/* eslint-disable no-restricted-globals */
import { Dialog } from "@mui/material"
import Slide from "@mui/material/Slide"
import { CreateComponent } from "components/utils/CreateComponent"
import React, { useEffect, useLayoutEffect, useState } from "react"
import { rootStore } from "store/RootStore"
import { EventEmitter } from "components/utils/EventEmitter"
import { CALLING_CONTEXT_TYPE } from "store/page/OverlayEventDetails"
import { isMobileScreenSize } from "utils/Utils"
import { useNavigate, useLocation } from "react-router";
import { DiscoverCategoryComponent } from "scenes/Discover/DiscoverCategoryComponent"
import { debounce } from "lodash"
import { ErrorMessage } from "components/ErrorMessage"
import { timeNow } from "utils/Utils"
import { PROGRAM_ORIGIN } from "scenes/components/EpgChannelDetailsInfo"
import { analyticsScreen, analyticsMeta } from "store/qlapi/LogService"

import "scenes/Overlay/OverlayEventDetails.css"

const styles = theme => ({

	container: {
		display: "flex",
		justifyContent: "center",
		alignItems: "flex-Start",
	},
	containerWithErrorEvent: {
		display: "flex",
		justifyContent: "center",
		alignItems: "center",
	},

	modalPortraitMode: {
		maxWidth: "100%",
		margin: "auto",
	},

	modalLandscapeMode: {
		maxWidth: "70%",
		margin: "auto",
	},

	overlayDialogPaper: {
		overflowX: "hidden",
		borderRadius: "16px",
		boxShadow: "0 2px 50px 0 rgba(0, 0, 0, 0.5)"
	},

	// not really needed, just for dialog scroll trial (which does not work)
	overlayDialog: {
		overflowY: "scroll",
		//scrollbarWidth: "none",
		marginTop: 0,
		"&::-webkit-scrollbar": { display: "none" },
		//paddingBottom: 3
	},
})


const Transition = React.forwardRef((props, ref) => <Slide direction="up" {...props} />)

const DiscoverModalBody = CreateComponent(styles, false, true, ({ classes, page }) => {
	const [orientationClass, setOrientationClass] = useState(classes.modalPortraitMode)
	const navigate = useNavigate()
	const location = useLocation()

	const closeModalForBack = (event) => {
		//history.push(location.pathname)
		navigate(location.pathname)
		page.setIsPlayerPresent(false)
		page.setShow(false)
		// MTVW-624: combined activityStack for related content and search
		page.resetActivity();
	}

	function checkOrientationOnMobile(event = null) {
		if (event !== null) {
			event.stopPropagation();
			event.preventDefault();
		}
		setTimeout(() => { // need delay for updating window
			const switchToLandscape = window.innerWidth > window.innerHeight

			//if (window.innerWidth <= 812) {
			if (isMobileScreenSize()) {
				if (switchToLandscape) {
					setOrientationClass(classes.modalLandscapeMode)
				} else {
					setOrientationClass(classes.modalPortraitMode)
				}
			} else {
				setOrientationClass(classes.modalPortraitMode)
			}
		}, 100)
	}

	function handleResize() {
		// timeout to assure window.innerWidth
		setTimeout(() => {
			const modalWidth = window.innerWidth > 1024 + 160 ? window.innerWidth - 160 : window.innerWidth
			page.setModalWidth(modalWidth)
			page.setModalHeight(window.innerHeight)
		}, 50)
	}

	useEffect((props) => {
		if (page.isShow) {
			rootStore.logService.analyticsScreenview({ [analyticsMeta.screen]: analyticsScreen.discoverCategory, category: rootStore.page.Discover?.discoverCategory?.topCategory?.id })
			window.addEventListener("resize", debounce(handleResize, 100))
			window.addEventListener("orientationchange", checkOrientationOnMobile)
			window.addEventListener("popstate", closeModalForBack)
			handleResize()
			checkOrientationOnMobile() //MTV-2537 call every time the modal is shown to adjust the size of the window 
		}
		return (() => {
			window.removeEventListener("resize", debounce(handleResize, 100))
			window.removeEventListener("orientationchange", checkOrientationOnMobile)
			window.removeEventListener("popstate", closeModalForBack)
		})
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, [page.isShow])

	/*
	useEffect(() => {
		EventEmitter.subscribe("closeOverlayDialog", (event) => {
			page.setShow(false)
		})
	}, [page])
	*/

	useLayoutEffect(() => {
		const dialog = document.getElementById("discover-modal")
		if (dialog) {
			dialog.focus()
		}
	})

	const errorOrigin = rootStore.page.OverlayEventDetails.oEvent?.error ? rootStore.page.OverlayEventDetails.oEvent?.error : rootStore.page?.Player?.error
	const pageForErrorMessage = rootStore.page.OverlayEventDetails.oEvent?.error ? rootStore.page.OverlayEventDetails.oEvent : rootStore.page?.Player
	const isPlayerError = rootStore.page?.Player?.error !== null

	let dialogInstance = null

	return (
		<Dialog
			open={page.isShow}
			//data-test="livetv_channel_summary_overlay"
			// MTVW-727b: disable backdropClick, close PiP on exit

			// MTVW-933: parentSelector doesn't work
			//container={document.getElementById("pageWrapper")}
			/*
			parentSelector={
				() => document.body
				// Function that will be called to get the parent element
				//	that the modal will be attached to.
			}
			*/
			//parentSelector={() => document.getElementById("pageWrapper")}

			onClose={(event, reason) => {
				event.preventDefault()
				event.stopPropagation()
				console.debug("closing categories modal", event, reason)
				// MTVW-941: no need to add || rootStore.page.Player.player.isFullScreen?
				if (reason === "escapeKeyDown" && rootStore.page.Player.player.isFullScreenCinema) {
					rootStore.page.Player.player.setFullScreen(false, true)
					page.setShow(true)
					return
				}
				// MTVW-988: close on backdrop click
				/*
				if (reason == "backdropClick") {
					page.setShow(true)
				}
				*/
				else {
					rootStore.page?.Player.player.showPiP(false).then(() => {
						//page.setIsPlayerPresent(false)
						page.setShow(false)
						// MTVW-624: combined activityStack for related content and search
						//page.resetActivity()
					}).catch((err) => console.error("CAUGHT in Dialog close"))
				}
			}}
			// DO NOT USE! It adds a vertical offset when using getBoundingClientRect in HeroTile
			//TransitionComponent={Transition}
			keepMounted
			id="discover-modal"
			tabIndex="-1" // make it focusable for keyboard ESC
			transitionDuration={200}
			// MTVW-810: TODO recheck error case
			//maxWidth={page.oEvent?.error ? "xs" : "md"} // MTVW-186 need xs in case of event error
			sx={{
				display: "flex",
				margin: "auto",
				width: page.modalWidth,
				maxWidth: page.modalWidth,
				zIndex: "1300 !important", // default modal value
				"& .MuiDialog-container": {
					scrollbarWidth: "none",
					width: page.modalWidth,
					maxWidth: page.modalWidth,
					"& .MuiPaper-root": {
						//width: "100%",
						width: page.modalWidth,
						maxWidth: page.modalWidth,
						height: "100%",
						margin: "0px" // mobile would otherwise have a margin of 32px
					},
				},
				"& .MuiDialog-paper": {
					borderRadius: "16px",
				},
				"& .MuiModal-backdrop": {
					backgroundColor: 'rgba(48,48,48,0.8)',
				},
			}}
			// deprecated, moved to sx above
			//BackdropProps={{ style: { backgroundColor: "rgba(48,48,48,0.8)" } }}
			// deprecated
			//PaperProps={{ sx: { backgroundColor: "#1A1A1A" } }}
			slotProps={{
				paper: {
					sx: { backgroundColor: "#1A1A1A" }
				}
			}}
			scroll="body"
			//disablePortal={true}
			//placement="top"
			className="overlayDialog"
			ref={dialog => { dialogInstance = dialog; /*console.debug("dialogInstance is", dialogInstance)*/ }}
			target="#discover-modal"
			classes={{
				container: page.oEvent?.error ? classes.containerWithErrorEvent : classes.container,
				scrollBody: orientationClass,
				paper: classes.overlayDialogPaper
			}}
			style={{ outline: "none" }} // no Blue border 
		>
			<div className="ErrorPosition" >
				{(!rootStore.page.OverlayEventDetails.isPlayerPresent || page.isShow) && (
					<ErrorMessage error={errorOrigin} isPlayerError={isPlayerError} classes={{ ErrorInfoWrapper: "ErrorInfoWrapper" }} page={pageForErrorMessage} id={"overlay"} />
				)}
			</div>
			{/*console.debug("innerWidth", window.innerWidth, window.visualViewport.width)*/}
			{page.isShow &&
				<DiscoverCategoryComponent page={page} origin={PROGRAM_ORIGIN.overlay} />
			}
		</Dialog>
	)
})

export const DiscoverModal = CreateComponent(null, false, false, () => {
	const page = rootStore.page.Discover
	//useEffect(...page.getMountBody())
	return <DiscoverModalBody page={page} />

})
